const Spinner = props => {
    return (
        <div className={"spinner-wrapper" + (props.button ? ' spinner-wrapper--button' : '') + (props.fullHeight ? ' spinner-wrapper--full-height' : '')}>
            <div className="spinner"/>
        </div>
    );
}

export default Spinner;
